import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import FeaturePackService from '../services/FeaturePackService';

const FeaturePackContext = createContext();

export function FeaturePackProvider({ children }) {
  const service = useMemo(() => new FeaturePackService(), []);
  const [data, setData] = useState(() => service.get());

  useEffect(() => {
    const refresh = () => setData(service.get());
    window.addEventListener('storage', refresh);
    window.addEventListener('packs:updated', refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('packs:updated', refresh);
    };
  }, [service]);

  const value = useMemo(
    () => ({
      packs: data.packs || {},
      workspaceId: data.workspaceId || 'default',
      updatedBy: data.updatedBy,
      updatedAt: data.updatedAt,
      setPacks: (next, user) => setData(service.update(next, user)),
      refresh: () => setData(service.get())
    }),
    [data, service]
  );

  return <FeaturePackContext.Provider value={value}>{children}</FeaturePackContext.Provider>;
}

export function useFeaturePacks() {
  const context = useContext(FeaturePackContext);
  if (!context) {
    const service = new FeaturePackService();
    const data = service.get();
    return {
      packs: data.packs || {},
      workspaceId: data.workspaceId || 'default',
      setPacks: () => {},
      refresh: () => {}
    };
  }
  return context;
}
